import React from 'react';
import { useErase, useColor } from '../../../state/UserProvider';

export default function Brush() {
  const { erase } = useErase();
  const { color } = useColor();

  return (
    <>
      {erase ? (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="61" height="61" fill="#E5E5E5" />
          <g id="Stamp tool - selected" clipPath="url(#clip0_130_410)">
            <rect
              width="360"
              height="640"
              transform="translate(-79.0432 -563.772)"
              fill="white"
            />
            <g id="Bottom Control Bar" filter="url(#filter0_d_130_410)">
              <rect
                width="360"
                height="92"
                transform="translate(-79.0432 -15.772)"
                fill="white"
              />
              <g id="Button">
                <g id="Icon">
                  <path
                    id="Union"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.4412 18.228H39.3943C40.299 18.228 41.0349 18.964 41.0349 19.8687V27.3687H20.8787V19.8687C20.8787 18.964 21.6145 18.228 22.5193 18.228H30.3474V23.1499C30.3474 23.5382 30.6621 23.853 31.0505 23.853C31.4389 23.853 31.7537 23.5382 31.7537 23.1499V18.228H35.0349V24.5562C35.0349 24.9445 35.3496 25.2593 35.738 25.2593C36.1264 25.2593 36.4412 24.9445 36.4412 24.5562V18.228ZM25.8005 33.6968H36.113C38.827 33.6968 41.0349 31.489 41.0349 28.7749H20.8787C20.8787 31.489 23.0865 33.6968 25.8005 33.6968ZM35.1099 35.103H26.8035L26.5385 37.2232C26.3802 38.4899 26.7739 39.7653 27.6187 40.7222C28.4636 41.679 29.6802 42.228 30.9568 42.228C32.2334 42.228 33.45 41.679 34.2947 40.7222C35.1397 39.7653 35.5333 38.4899 35.3749 37.2232L35.1099 35.103ZM30.9568 38.7124C30.5683 38.7124 30.2537 38.3976 30.2537 38.0093C30.2537 37.6209 30.5683 37.3062 30.9568 37.3062C31.3451 37.3062 31.6599 37.6209 31.6599 38.0093C31.6599 38.3976 31.3451 38.7124 30.9568 38.7124Z"
                    fill="#393939"
                  />
                </g>
              </g>
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_130_410"
              x="-109.043"
              y="-47.772"
              width="420"
              height="152"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="-2" />
              <feGaussianBlur stdDeviation="15" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_130_410"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_130_410"
                result="shape"
              />
            </filter>
            <clipPath id="clip0_130_410">
              <rect
                width="360"
                height="640"
                fill="white"
                transform="translate(-79.0432 -563.772)"
              />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" fill="#E5E5E5" />
          <g
            id="Color picker - return to artboard"
            clipPath="url(#clip0_130_410)"
          >
            <rect
              width="360"
              height="640"
              transform="translate(-78.0433 -561.772)"
              fill="white"
            />
            <g id="Bottom Control Bar" filter="url(#filter0_d_130_410)">
              <rect
                width="360"
                height="92"
                transform="translate(-78.0433 -13.772)"
                fill="white"
              />
              <g id="Button">
                <rect
                  id="Body"
                  x="5.95667"
                  y="6.22803"
                  width="52"
                  height="52"
                  rx="12"
                  fill={color}
                />
                <g id="Icon">
                  <g id="Union">
                    <mask
                      id="path-2-outside-1_130_410"
                      maskUnits="userSpaceOnUse"
                      x="19.8785"
                      y="18.228"
                      width="25"
                      height="28"
                      fill="black"
                    >
                      <rect
                        fill="white"
                        x="19.8785"
                        y="18.228"
                        width="25"
                        height="28"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M37.441 20.228H40.3942C41.2989 20.228 42.0348 20.964 42.0348 21.8687V29.3687H21.8785V21.8687C21.8785 20.964 22.6143 20.228 23.5192 20.228H31.3473V25.1499C31.3473 25.5382 31.6619 25.853 32.0504 25.853C32.4387 25.853 32.7535 25.5382 32.7535 25.1499V20.228H36.0348V26.5562C36.0348 26.9445 36.3494 27.2593 36.7379 27.2593C37.1262 27.2593 37.441 26.9445 37.441 26.5562V20.228ZM26.8004 35.6968H37.1129C39.8268 35.6968 42.0348 33.489 42.0348 30.7749H21.8785C21.8785 33.489 24.0864 35.6968 26.8004 35.6968ZM36.1098 37.103H27.8034L27.5384 39.2232C27.3801 40.4899 27.7738 41.7653 28.6186 42.7222C29.4635 43.679 30.6801 44.228 31.9567 44.228C33.2333 44.228 34.4498 43.679 35.2946 42.7222C36.1395 41.7653 36.5331 40.4899 36.3748 39.2232L36.1098 37.103ZM31.9567 40.7124C31.5682 40.7124 31.2536 40.3976 31.2536 40.0093C31.2536 39.6209 31.5682 39.3062 31.9567 39.3062C32.345 39.3062 32.6598 39.6209 32.6598 40.0093C32.6598 40.3976 32.345 40.7124 31.9567 40.7124Z"
                      />
                    </mask>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M37.441 20.228H40.3942C41.2989 20.228 42.0348 20.964 42.0348 21.8687V29.3687H21.8785V21.8687C21.8785 20.964 22.6143 20.228 23.5192 20.228H31.3473V25.1499C31.3473 25.5382 31.6619 25.853 32.0504 25.853C32.4387 25.853 32.7535 25.5382 32.7535 25.1499V20.228H36.0348V26.5562C36.0348 26.9445 36.3494 27.2593 36.7379 27.2593C37.1262 27.2593 37.441 26.9445 37.441 26.5562V20.228ZM26.8004 35.6968H37.1129C39.8268 35.6968 42.0348 33.489 42.0348 30.7749H21.8785C21.8785 33.489 24.0864 35.6968 26.8004 35.6968ZM36.1098 37.103H27.8034L27.5384 39.2232C27.3801 40.4899 27.7738 41.7653 28.6186 42.7222C29.4635 43.679 30.6801 44.228 31.9567 44.228C33.2333 44.228 34.4498 43.679 35.2946 42.7222C36.1395 41.7653 36.5331 40.4899 36.3748 39.2232L36.1098 37.103ZM31.9567 40.7124C31.5682 40.7124 31.2536 40.3976 31.2536 40.0093C31.2536 39.6209 31.5682 39.3062 31.9567 39.3062C32.345 39.3062 32.6598 39.6209 32.6598 40.0093C32.6598 40.3976 32.345 40.7124 31.9567 40.7124Z"
                      fill="white"
                    />
                    <path
                      d="M37.441 20.228V18.228H35.441V20.228H37.441ZM42.0348 29.3687V31.3687H44.0348V29.3687H42.0348ZM21.8785 29.3687H19.8785V31.3687H21.8785V29.3687ZM31.3473 20.228H33.3473V18.228H31.3473V20.228ZM32.7535 20.228V18.228H30.7535V20.228H32.7535ZM36.0348 20.228H38.0348V18.228H36.0348V20.228ZM42.0348 30.7749H44.0348V28.7749H42.0348V30.7749ZM21.8785 30.7749V28.7749H19.8785V30.7749H21.8785ZM27.8034 37.103V35.103H26.0378L25.8188 36.855L27.8034 37.103ZM36.1098 37.103L38.0944 36.855L37.8754 35.103H36.1098V37.103ZM27.5384 39.2232L29.523 39.4713L29.523 39.4713L27.5384 39.2232ZM28.6186 42.7222L27.1193 44.0459L27.1194 44.046L28.6186 42.7222ZM35.2946 42.7222L33.7955 41.3983L33.7953 41.3985L35.2946 42.7222ZM36.3748 39.2232L34.3902 39.4713L34.3902 39.4713L36.3748 39.2232ZM40.3942 18.228H37.441V22.228H40.3942V18.228ZM44.0348 21.8687C44.0348 19.8594 42.4034 18.228 40.3942 18.228V22.228C40.1943 22.228 40.0348 22.0685 40.0348 21.8687H44.0348ZM44.0348 29.3687V21.8687H40.0348V29.3687H44.0348ZM21.8785 31.3687H42.0348V27.3687H21.8785V31.3687ZM19.8785 21.8687V29.3687H23.8785V21.8687H19.8785ZM23.5192 18.228C21.5096 18.228 19.8785 19.8595 19.8785 21.8687H23.8785C23.8785 22.0684 23.719 22.228 23.5192 22.228V18.228ZM31.3473 18.228H23.5192V22.228H31.3473V18.228ZM33.3473 25.1499V20.228H29.3473V25.1499H33.3473ZM32.0504 23.853C32.7668 23.853 33.3473 24.4339 33.3473 25.1499H29.3473C29.3473 26.6425 30.5571 27.853 32.0504 27.853V23.853ZM30.7535 25.1499C30.7535 24.4337 31.3342 23.853 32.0504 23.853V27.853C33.5433 27.853 34.7535 26.6428 34.7535 25.1499H30.7535ZM30.7535 20.228V25.1499H34.7535V20.228H30.7535ZM36.0348 18.228H32.7535V22.228H36.0348V18.228ZM38.0348 26.5562V20.228H34.0348V26.5562H38.0348ZM36.7379 25.2593C37.4543 25.2593 38.0348 25.8402 38.0348 26.5562H34.0348C34.0348 28.0488 35.2446 29.2593 36.7379 29.2593V25.2593ZM35.441 26.5562C35.441 25.8399 36.0217 25.2593 36.7379 25.2593V29.2593C38.2308 29.2593 39.441 28.0491 39.441 26.5562H35.441ZM35.441 20.228V26.5562H39.441V20.228H35.441ZM37.1129 33.6968H26.8004V37.6968H37.1129V33.6968ZM40.0348 30.7749C40.0348 32.3844 38.7223 33.6968 37.1129 33.6968V37.6968C40.9314 37.6968 44.0348 34.5936 44.0348 30.7749H40.0348ZM21.8785 32.7749H42.0348V28.7749H21.8785V32.7749ZM26.8004 33.6968C25.1909 33.6968 23.8785 32.3844 23.8785 30.7749H19.8785C19.8785 34.5935 22.9818 37.6968 26.8004 37.6968V33.6968ZM27.8034 39.103H36.1098V35.103H27.8034V39.103ZM29.523 39.4713L29.788 37.3511L25.8188 36.855L25.5539 38.9752L29.523 39.4713ZM30.1179 41.3985C29.6528 40.8718 29.4358 40.1688 29.523 39.4713L25.5539 38.9751C25.3244 40.811 25.8948 42.6589 27.1193 44.0459L30.1179 41.3985ZM31.9567 42.228C31.2539 42.228 30.5832 41.9255 30.1178 41.3983L27.1194 44.046C28.3438 45.4325 30.1062 46.228 31.9567 46.228V42.228ZM33.7953 41.3985C33.3301 41.9255 32.6595 42.228 31.9567 42.228V46.228C33.8071 46.228 35.5696 45.4325 36.7939 44.0459L33.7953 41.3985ZM34.3902 39.4713C34.4775 40.1689 34.2604 40.8718 33.7955 41.3983L36.7938 44.046C38.0187 42.6589 38.5888 40.8109 38.3593 38.9751L34.3902 39.4713ZM34.1252 37.3511L34.3902 39.4713L38.3594 38.9752L38.0944 36.855L34.1252 37.3511ZM29.2536 40.0093C29.2536 41.5019 30.4634 42.7124 31.9567 42.7124V38.7124C32.673 38.7124 33.2536 39.2933 33.2536 40.0093H29.2536ZM31.9567 37.3062C30.4634 37.3062 29.2536 38.5166 29.2536 40.0093H33.2536C33.2536 40.7252 32.673 41.3062 31.9567 41.3062V37.3062ZM34.6598 40.0093C34.6598 38.5164 33.4496 37.3062 31.9567 37.3062V41.3062C31.2404 41.3062 30.6598 40.7255 30.6598 40.0093H34.6598ZM31.9567 42.7124C33.4496 42.7124 34.6598 41.5022 34.6598 40.0093H30.6598C30.6598 39.293 31.2404 38.7124 31.9567 38.7124V42.7124Z"
                      fill={color}
                      mask="url(#path-2-outside-1_130_410)"
                    />
                  </g>
                </g>
                <rect
                  id="Outline"
                  x="1.95667"
                  y="2.22803"
                  width="60"
                  height="60"
                  rx="12"
                  stroke={color}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeDasharray="5 5"
                />
              </g>
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_130_410"
              x="-108.043"
              y="-45.772"
              width="420"
              height="152"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="-2" />
              <feGaussianBlur stdDeviation="15" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_130_410"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_130_410"
                result="shape"
              />
            </filter>
            <clipPath id="clip0_130_410">
              <rect
                width="360"
                height="640"
                fill="white"
                transform="translate(-78.0433 -561.772)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
}
